import { FC } from 'react';
import useApigeeLabels from 'common/ApigeeLabels/hooks/useApigeeLabels';
import { PlasticBagPackingInfo } from 'network/response/ICart';

import EPaymentMethods from 'pages/Checkout/components/Payment/PamentMethods.enum';
import ReadAboutOurFee from 'pages/Checkout/components/ReadAboutOurFee/index';
import OrderSummaryRow from 'common/OrderSummary/components/OrderSummaryRow';

import useOrderSummary from 'common/OrderSummary/hooks/useOrderSummary.hook';
import PackingFeeRow from 'common/PackingFeeRow';

const CheckoutSummaryFees: FC<{
  plasticBagPackingInfo?: PlasticBagPackingInfo;
  sustainabilityConsent: boolean | null;
}> = ({ plasticBagPackingInfo, sustainabilityConsent }) => {
  const {
    paymentMode,
    codFee,
    totalDeliveryCost,
    totalServiceFee,
    totalSurCharge,
  } = useOrderSummary();

  const { codFee: codFeeLabel, deliveryFee, packagingFee, serviceFee, slotFee } = useApigeeLabels();

  return (
    <>
      {!!totalDeliveryCost && (
        <OrderSummaryRow
          label={deliveryFee}
          priceDetails={totalDeliveryCost || { value: 0 }}
          shouldShowFree
          testId="total-delivery-fee"
        />
      )}

      {!!totalServiceFee && (
        <OrderSummaryRow
          label={serviceFee}
          priceDetails={totalServiceFee || {}}
          testId="total-service-fee"
        />
      )}

      {!!totalSurCharge && (
        <OrderSummaryRow
          label={slotFee}
          priceDetails={totalSurCharge || {}}
          testId="total-slot-fee"
        />
      )}

      <PackingFeeRow
        plasticBagPackingInfo={plasticBagPackingInfo}
        sustainabilityConsent={sustainabilityConsent}
        label={packagingFee}
      />

      {paymentMode === EPaymentMethods.COD && !!codFee && codFee.value > 0 && (
        <OrderSummaryRow label={codFeeLabel} priceDetails={codFee} testId="total-cod-fee" />
      )}

      <ReadAboutOurFee />
    </>
  );
};

export default CheckoutSummaryFees;
